<template>
    <div class="primer">
        
        <div id="primer-landing">
            <div class = "img1"></div>
            <div class = "img2"></div>
            <div class="primer-landing-container">
                
                <h1>Your MISA Family</h1>
                <h4>Having trouble picking which cluster and position might be for you? Check out our primer for descriptions for our ideal incoming Wave 2 Officer!</h4>

                <h3><b>Choose your Cluster</b></h3>
                <div class="cluster-picker">
                    <button class="secondary-btn" v-on:click="openInfo('osg-tab')">Office of the Secretary General</button>
                    <button class="secondary-btn" v-on:click="openInfo('oet-tab')">Office of the Executive Treasurer</button>
                    <button class="secondary-btn" v-on:click="openInfo('comms-tab')">Communications</button>
                    <button class="secondary-btn" v-on:click="openInfo('hr-tab')">Human Resources</button>
                    <button class="secondary-btn" v-on:click="openInfo('marketing-tab')">Marketing</button>
                    <button class="secondary-btn" v-on:click="openInfo('events-tab')">Events</button>
                    <button class="secondary-btn" v-on:click="openInfo('eservs-tab')">eServices</button>
                </div>
            </div>
            
        </div>
        <div id="clusters-info">
            <!-- <Clusters/> -->
            <br>
            <br>
            <br>
            <a v-on:click="hidePrimer">&#60; <u>BACK</u></a>

            <div class="tab">
                <button class="secondary-btn tablinks" v-on:click="openTab($event, 'osg')" id="osg-tab">OSG</button> 
                <button class="secondary-btn tablinks" v-on:click="openTab($event, 'oet')" id="oet-tab">OET</button>
                <button class="secondary-btn tablinks" v-on:click="openTab($event, 'comms')" id="comms-tab">Comms</button>
                <button class="secondary-btn tablinks" v-on:click="openTab($event, 'hr')" id="hr-tab">HR</button>
                <button class="secondary-btn tablinks" v-on:click="openTab($event, 'marketing')" id="marketing-tab">Marketing</button>
                <button class="secondary-btn tablinks" v-on:click="openTab($event, 'events')" id="events-tab">Events</button>
                <button class="secondary-btn tablinks" v-on:click="openTab($event, 'eservs')" id="eservs-tab">eServs</button>
            </div>

            <div id="osg" class="tabcontent">
                <PrimerOSG/>

                <!-- <div class="modal" id="modal">
                    <div class="modal-container">
                        <div class="button-container">
                            <button class="close-btn" v-on:click="hideModal()">Close</button>
                        </div>
                        
                        <div>
                            <h2>New Positions Alert 🚨</h2>
                            <h5>For the Office of the Secretary General, we have added new positions to further improve the organization. We can't wait for you to join the team and see what’s in store!</h5>
                        </div>
                    </div>
                </div>       -->
            </div>

            <div id="oet" class="tabcontent">
                <PrimerOET/>
            </div>

            <div id="comms" class="tabcontent">
                <PrimerComms/>
            </div>

            <div id="hr" class="tabcontent">
                <PrimerHR/>
            </div>

            <div id="marketing" class="tabcontent">
                <PrimerMarketing/>
            </div>

            <div id="events" class="tabcontent">
                <PrimerEvents/>
            </div>

            <div id="eservs" class="tabcontent">
                <PrimerEservs/>
            </div>
        </div>
    </div>
</template>

<script>
    // import Clusters from '../components/Clusters.vue'

        
    import PrimerOSG from '../components/cluster-specific/PrimerOSG.vue'
    import PrimerOET from '../components/cluster-specific/PrimerOET.vue'
    import PrimerComms from '../components/cluster-specific/PrimerComms.vue'
    import PrimerMarketing from '../components/cluster-specific/PrimerMarketing.vue'
    import PrimerHR from '../components/cluster-specific/PrimerHR.vue'
    import PrimerEvents from '../components/cluster-specific/PrimerEvents.vue'
    import PrimerEservs from '../components/cluster-specific/PrimerEservs.vue'

    export default {
        name: 'Primer',
        components: {
            PrimerOSG,
            PrimerOET,
            PrimerComms,
            PrimerMarketing,
            PrimerHR,
            PrimerEvents,
            PrimerEservs
        },
        methods: {
            openTab: function (evt, clusterName) {
                // Declare all variables
                var i, tabcontent, tablinks;

                // Get all elements with class="tabcontent" and hide them
                tabcontent = document.getElementsByClassName("tabcontent");
                for (i = 0; i < tabcontent.length; i++) {
                    tabcontent[i].style.display = "none";
                }

                // Get all elements with class="tablinks" and remove the class "active"
                tablinks = document.getElementsByClassName("tablinks");
                for (i = 0; i < tablinks.length; i++) {
                    tablinks[i].className = tablinks[i].className.replace(" active", "");
                }

                // Show the current tab, and add an "active" class to the button that opened the tab
                document.getElementById(clusterName).style.display = "block";
                evt.currentTarget.className += " active";

                if (clusterName == "osg"){
                    document.getElementById("modal").style.display = "block";
                }
            },

            hideModal: function () {
                document.getElementById("modal").style.display = "none";
            },

            hidePrimer: function () {
                document.getElementById("primer-landing").style.display = "block";
                document.getElementById("clusters-info").style.display = "none";
            },

            openInfo: function (cluster) {
                
                document.getElementById("primer-landing").style.display = "none";
                document.getElementById("clusters-info").style.display = "block";
                document.getElementById(cluster).click();
                
            }
        },

        mounted() {
            // document.getElementById("defaultOpen").click();
            document.getElementById("clusters-info").style.display = "none";
            // document.getElementById("modal").style.display = "none";
        } 
    }
</script>

<style scoped>
    .primer-landing-container{
        padding: 0px;
        margin: 0;
    }

    .modal{
        display: block; /* Hidden by default */
        position: fixed; /* Stay in place */
        z-index: 1; /* Sit on top */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0,0,0); /* Fallback color */
        background-color: rgba(0,0,0,0.18); /* Black w/ opacity */
    }

    .modal-container{
        z-index: 2;
        padding: 1vw;
        background: white;
        border-radius: 15px;
        /* border: 2px solid #31A5AF; */
        margin: 20vh auto;
        max-width: 400px;
    }

    .button-container{
        display: flex;
        flex-direction: row-reverse;
        width: 100%;
    }

    .modal-container button{
        margin: 0;
        border: 4px solid #DE2717;
        border-radius: 12px;
        background-color: white;
        text-align: center;
        justify-items: center;
        color: #DE2717;
        /* position: relative; */
    }

    .modal-container button:hover{
        
        border: 4px solid #DE2717;
        background-color: #DE2717;
        color: #fff;
        /* position: relative; */
    }
    
    

    .primer{
        top:0;
        left:0;
        bottom:0;
        right:0;
        margin:0px;
        padding:0px;
        padding-top: 96px;
        padding-bottom: 80px;
        /* overflow: hidden; */
        
    }
    .cluster-picker{
        max-width: 900px;
        margin-top: -15px;
    }

    .cluster-picker button{
        height: 56px;
        /* font-size: 20px; */
        padding: 0 16px;
        margin-right: 25px;
        margin-top: 15px;
        position: relative;
    }


    #primer-landing{
        display: block;
        /* height: 101vh; */
        /* margin-bottom: 120px; */
        margin-left: 16vw;
        margin-right: 10.30vw;
        padding-top: 10px;
        height: 100%;
        /* padding-bottom: 80px; */
    }

    #clusters-info{
        /* padding-top: 80px; */
        /* overflow: hidden; */
        display: block;
        padding: 0px 8vw;
        padding-bottom: 80px;
    }

    a {
        /* text-decoration: underline; */
        cursor: pointer;
    }

    /* primer cluster style */
    .clusters-page{
        margin: 56px 0px;
        padding-right: 6vw;
    }
    .cluster-nav{
        display: flex;
        flex-flow: row wrap;
    }

    .cluster-nav button {
        margin-right: 16px;
        /* height: 29px; */
    }

    .tab {
        overflow: hidden; 
        margin-top: 16px;
    }

    .tab button {
        padding: 8px;
        font-weight: 600;
        font-size: 12px;
        margin-right: 18px;
        margin-top: 16px;
    }

    .active {
        background-color: #31A5AF;
        color: white;

        /* for testing */
        /* height: 42px;  */
    }

    .tabcontent {
        display: none;
        max-width: 1200px;
    }

    .img1{
        top:0;
        left:0;
        bottom:0;
        right:0;
        margin:0px;
        padding:0px;
        position: absolute;
        background-position: 
        top 10vw left 67.2vw,
        bottom 0vw left 0vw;
        
        background-image:
        url('~@/assets/primer.png'),
        url('~@/assets/prime.png');
        
        
        width: 100%;
        height:49vw;
        background-size:32vw;
        background-repeat: no-repeat;
        /* overflow: auto; */
        z-index: -2;
    }

    @media only screen and (max-width: 1353px) {
        .img1{
            display: none;
        }
    }

    /* @media only screen and (max-width: 679px) {
        .img2{
            display: none;
        }
    } */

    h1{
        /* font-size: 80px; */
        margin-top: 0px;
        margin-bottom:20px;
    }
    h3{
        padding:0px;
        margin-top:40px;
    }
    h4{
        padding:0px;
        margin-top:10px;
        max-width: 700px;
    }
</style>


